import useTypewriter from "@/hooks/useTypewriter";

const TEXT = "Tecnologia e infraestrutura desde 2007";

/**
 * Selo de destaque da hero, exibido com efeito de máquina de escrever
 * e um cursor fino piscando ao final da digitação.
 */
export default function HeroBadge() {
  const { displayed, done } = useTypewriter(TEXT, 32, 150);

  return (
    <span
      aria-label={TEXT}
      className="inline-flex items-center gap-2.5 rounded-full border border-background-50/15 bg-background-50/5 px-5 py-2.5 text-sm font-medium tracking-wide text-accent-300 md:text-base"
    >
      <i className="ri-flashlight-line text-base text-accent-400 md:text-lg" aria-hidden="true"></i>
      <span aria-hidden="true">
        {displayed}
        {!done ? (
          <span className="ml-0.5 inline-block h-[0.9em] w-[2px] translate-y-[0.08em] animate-blink bg-accent-400 align-baseline"></span>
        ) : null}
      </span>
    </span>
  );
}